import React from 'react';
import { FunctionField, useRecordContext } from 'react-admin';
import { DisplayHelpers } from 'utils/helpers';
import BlendedRateField from './BlendedRateField';
import { RateSettingsDisplayHelper } from 'utils/displayHelpers/rate-settings';

export const ChargeRateCentsField = ({
  isLocationTypePositionRateSetting,
  nestedOperator,
  isLocationPositionRateSetting,
}) => {
  const record = useRecordContext();
  const { settings, location, with_markup_settings } = record;
  const { ten99, w2 } = settings;
  const rateSettingsDisplayHelper = new RateSettingsDisplayHelper({ settings, location });
  const activeRate = rateSettingsDisplayHelper.getActiveRate(nestedOperator);
  const chargeRateCents = rateSettingsDisplayHelper.getActiveChargeRateCents(nestedOperator);

  const isBlended = activeRate === 'blended-rate';
  const showBlendedRate = isBlended && !isLocationPositionRateSetting;

  if (
    !ten99?.charge_rate_cents &&
    !w2?.local?.charge_rate_cents &&
    !w2?.travel?.charge_rate_cents
  ) {
    return null;
  }

  if (isLocationTypePositionRateSetting) {
    return (
      <FunctionField
        render={() => {
          const isW2 = nestedOperator.includes('w2');
          const classificationSettings = isW2
            ? with_markup_settings?.w2?.local
            : with_markup_settings?.ten99;

          return DisplayHelpers.money(classificationSettings?.charge_rate_cents);
        }}
      />
    );
  }

  if (chargeRateCents) {
    if (showBlendedRate) {
      return <BlendedRateField />;
    }
    return <FunctionField render={() => DisplayHelpers.money(chargeRateCents)} />;
  }
};

ChargeRateCentsField.defaultProps = {
  label: 'Location Rate',
};
